import React, { useState } from "react";
import style from "./style.module.css";
import image from "../../assets/lmsiLogin.png";
import { AuthLayout } from "../../components/layouts/AuthLayout";
import Grid from "@mui/material/Grid2";
import { Input } from "../../components/Input";
import {
  closedEyeIcon,
  openedEyeIcon,
} from "../../components/icons/commonIcons";
import {
  ETHNICITY_TYPES,
  Gender_Type,
  LANGUAGE_TYPES,
  RELIGION_TYPES,
  SESSION_TYPES,
} from "../../components/Constant/constants";
import { AutocompleteSelect } from "../../components/AutocompleteSelect";
import { useNavigate } from "react-router-dom";
import { CustomCheckbox } from "../../components/CustomCheckbox";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { uploadFileAws, userSignUp } from "../../Api/commonApi";
import { Country, State, City } from "country-state-city";
import { loader, toast } from "../../store/utilities";
import { Box, Dialog } from "@mui/material";
import { CancelOutlined } from "@mui/icons-material";
export default function SignUp({ dialog, setDialog }) {
  let navigate = useNavigate();
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [checkAgreement, setcheckAgreement] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const [check, setCheck] = useState(false);
  const [previewUrl, setPreviewUrl] = useState();
  const [selectedImage, setSelectedImage] = useState(null);
  const countries = Country.getAllCountries();
  const [selectedCountry, setSelectedCountry] = useState(
    countries.map((res) => ({
      label: res.name,
      value: res.name,
    }))
  );
  const validate = (password) => {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
      password
    );
  };
  const handleChangePass = (e) => {
    setPassword(e.target.value);

    setCheck(false);
  };
  const handleconfirmPass = (e) => {
    setConfirmPassword(e.target.value);

    setCheck(false);
  };

  const [userInfo, setUserInfo] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    gender: null,
    nationality: "",
    language: null,
    religion: null,
    profile_image: {
      file_name: "",
      file_url: "",
    },
  });
  const [Validation, setValidation] = useState({
    first_name: false,
    last_name: false,
    gender: false,
    nationality: false,
    language: false,
    religion: false,
    email: false,

    // password: false,
  });

  const checkValidation = () => {
    // if (!userInfo?.first_name) {
    //   setValidation((prevState) => ({
    //     ...prevState,
    //     first_name: true,
    //   }));
    // }

    // if (!userInfo?.last_name) {
    //   setValidation((prevState) => ({
    //     ...prevState,
    //     last_name: true,
    //   }));
    // }

    // if (!userInfo?.email) {
    //   setValidation((prevState) => ({
    //     ...prevState,
    //     email: true,
    //   }));
    // }

    // if (!password) {
    //   setValidation((prevState) => ({
    //     ...prevState,
    //     password: true,
    //   }));
    // }

    return Object.values(userInfo).every((value) => value); // Ensure all fields are filled
  };

  const handleInput = (e) => {
    const { name, value } = e.target;

    if (value === " ") {
      e.target.value = "";
    } else {
      setValidation((prev) => ({ ...prev, [name]: false }));
      setUserInfo((pre) => {
        return {
          ...pre,
          [name]: value,
        };
      });
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(file);
      const preview = URL.createObjectURL(file);
      setPreviewUrl(preview);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setUserInfo((prev) => ({
          ...prev,
          profile_image: {
            fileName: file.name,
            fileUrl: reader.result,
          },
        }));
      };
    }
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
    setPreviewUrl("");
    setUserInfo((prev) => ({
      ...prev,
      profile_image: { fileName: "", fileUrl: "" },
    }));
  };

  const handleSubmitFunction = async (e) => {
    e.preventDefault();
    // if (!checkValidation()) {
    //   console.log("Validation failed");
    //   return;
    // }
    try {
      loader.start();
      let payload = { ...userInfo, password };
      payload.gender = payload.gender?.value;
      payload.language = payload.language?.value;
      payload.religion = payload.religion?.value;
      if (selectedImage) {
        const formDatainfo = new FormData();
        formDatainfo.append("upload", selectedImage);
        let image = await uploadFileAws(formDatainfo).then(
          (res) => res.data.data
        );
        payload.profile_image.file_name = image.file_name;
        payload.profile_image.file_url = image.file_url;
      }
      const response = await userSignUp(payload);
      toast.success("User sign up successfully");
    } catch (err) {
      console.log(err);
    } finally {
      loader.stop();
      setDialog(false);
    }
  };
  return (
    // <AuthLayout img={image} direction={"rtl"}>
    <Dialog open={dialog} maxWidth="md" fullWidth={true}>
      <Box p={1} pb={0} className="text-end">
        <CancelOutlined
          className="pointer"
          onClick={() => {
            setDialog(false);
            setSelectedImage("");
          }}
        />
      </Box>
      <Box sx={{ p: 3, pt: 0 }}>
        <div className={style.signUp_container}>
          <div className={style.scrollableContainer}>
            <form className="w-100 " onSubmit={handleSubmitFunction}>
              <div>
                <div className="d-flex justify-content-center">
                  <div className={style.logo_con}>{/* <Logo /> */}</div>
                </div>

                <div className="d-flex justify-content-center mt-3">
                  <div className={style.heading}>Create your account</div>
                </div>
                <div className="d-flex justify-content-center mt-3">
                  <div className={style.welcomeBack}>
                    Welcome back! Please enter your details.
                  </div>
                </div>
                <br />
                <div className="d-flex justify-content-center mt-4">
                  {previewUrl ? (
                    <div style={{ marginBottom: "24px" }}>
                      <img
                        src={previewUrl}
                        alt="Preview"
                        style={{
                          width: "150px",
                          height: "150px",
                          borderRadius: "50%",
                          border: "4px solid #1890ff",
                          objectFit: "cover",
                        }}
                      />
                      <br />
                      <button
                        onClick={handleRemoveImage}
                        style={{
                          marginTop: "16px",
                          padding: "10px 20px",
                          fontSize: "14px",
                          backgroundColor: "#ff4d4f",
                          color: "white",
                          border: "none",
                          borderRadius: "8px",
                          cursor: "pointer",
                          boxShadow: "0px 4px 10px rgba(255, 77, 79, 0.2)",
                          transition: "background-color 0.3s",
                        }}
                        onMouseOver={(e) =>
                          (e.target.style.backgroundColor = "#d9363e")
                        }
                        onMouseOut={(e) =>
                          (e.target.style.backgroundColor = "#ff4d4f")
                        }
                      >
                        Remove Image
                      </button>
                    </div>
                  ) : (
                    <>
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        id="file-input"
                        onChange={handleImageChange}
                        onClick={() =>
                          setValidation((prev) => ({ ...prev, image: false }))
                        }
                      />
                      <label
                        htmlFor="file-input"
                        style={{
                          display: "inline-block",
                          width: "150px",
                          height: "150px",
                          borderRadius: "50%",
                          backgroundColor: "#f0f0f0",
                          color: "#999",
                          textAlign: "center",
                          lineHeight: "150px",
                          cursor: "pointer",
                          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                          transition: "background-color 0.3s",
                        }}
                        onMouseOver={(e) =>
                          (e.target.style.backgroundColor = "#e6f7ff")
                        }
                        onMouseOut={(e) =>
                          (e.target.style.backgroundColor = "#f0f0f0")
                        }
                        className={
                          Validation.image ? `border border-danger` : ""
                        }
                      >
                        <AccountCircleIcon
                          style={{
                            fontSize: "60px",
                            color: "#999",
                          }}
                        />
                      </label>
                    </>
                  )}
                </div>
                <Grid container spacing={1} className="mt-3">
                  {/* Your Input Fields */}
                  <Grid size={{ lg: 4, md: 6, sm: 12 }}>
                    <label className={style.label}>
                      First Name<span className="text-danger">*</span>
                    </label>
                    <Input
                      placeholder="Enter first name"
                      name="first_name"
                      required
                      value={userInfo.first_name}
                      onChange={handleInput}
                      className={
                        Validation.first_name
                          ? `${style.input} error_input`
                          : style.input
                      }
                      onClick={() =>
                        setValidation((prev) => ({
                          ...prev,
                          first_name: false,
                        }))
                      }
                    />
                  </Grid>
                  <Grid size={{ lg: 4, md: 6, sm: 12 }}>
                    <label className={style.label}>
                      Last Name<span className="text-danger">*</span>
                    </label>
                    <Input
                      placeholder="Enter last name"
                      name="last_name"
                      required
                      value={userInfo.last_name}
                      onChange={handleInput}
                      className={
                        Validation.last_name
                          ? `${style.input} error_input`
                          : style.input
                      }
                      onClick={() =>
                        setValidation((prev) => ({ ...prev, last_name: false }))
                      }
                    />
                  </Grid>
                  <Grid size={{ lg: 4, md: 6, sm: 12 }}>
                    <label className={style.label}>
                      Gender<span className="text-danger">*</span>
                    </label>
                    <AutocompleteSelect
                      required
                      getOptionLabel={(option) => option.value}
                      label={"Select gender"}
                      options={Gender_Type}
                      name="gender"
                      value={userInfo?.gender}
                      style={{
                        border: "1px solid white",
                        borderRadius: "8px",
                        backgroundColor: "white",
                      }}
                      onChange={(e, val) => {
                        setUserInfo((pre) => {
                          return {
                            ...pre,
                            gender: val,
                          };
                        });
                        setValidation((prev) => ({
                          ...prev,
                          gender: false,
                        }));
                      }}
                      className={
                        Validation.gender ? `error_input_autocompleate` : ""
                      }
                      onClick={() =>
                        setValidation((prev) => ({
                          ...prev,
                          gender: false,
                        }))
                      }
                    />
                  </Grid>
                  <Grid size={{ lg: 4, md: 6, sm: 12 }}>
                    <label className={style.label}>
                      Language<span className="text-danger">*</span>
                    </label>
                    <AutocompleteSelect
                      required
                      getOptionLabel={(option) => option.value}
                      label={"Select language"}
                      options={LANGUAGE_TYPES}
                      name="language"
                      value={userInfo?.language}
                      style={{
                        border: "1px solid white",
                        borderRadius: "8px",
                        backgroundColor: "white",
                      }}
                      onChange={(e, val) => {
                        setUserInfo((pre) => {
                          return {
                            ...pre,
                            language: val,
                          };
                        });
                        setValidation((prev) => ({
                          ...prev,
                          language: false,
                        }));
                      }}
                      className={
                        Validation.language ? `error_input_autocompleate` : ""
                      }
                      onClick={() =>
                        setValidation((prev) => ({
                          ...prev,
                          language: false,
                        }))
                      }
                    />
                  </Grid>
                  <Grid size={{ lg: 4, md: 6, sm: 12 }}>
                    <label className={style.label}>
                      Religion<span className="text-danger">*</span>
                    </label>
                    <AutocompleteSelect
                      required
                      getOptionLabel={(option) => option.value}
                      label={"Select religion"}
                      options={RELIGION_TYPES}
                      name="religion"
                      value={userInfo?.religion}
                      style={{
                        border: "1px solid white",
                        borderRadius: "8px",
                        backgroundColor: "white",
                      }}
                      onChange={(e, val) => {
                        setUserInfo((pre) => {
                          return {
                            ...pre,
                            religion: val,
                          };
                        });
                        setValidation((prev) => ({
                          ...prev,
                          religion: false,
                        }));
                      }}
                      className={
                        Validation.religion ? `error_input_autocompleate` : ""
                      }
                      onClick={() =>
                        setValidation((prev) => ({
                          ...prev,
                          industry_sector: false,
                        }))
                      }
                    />
                  </Grid>

                  <Grid size={{ lg: 4, md: 6, sm: 12 }}>
                    <label className={style.label}>Nationality</label>
                    <AutocompleteSelect
                      label={"Select nationality"}
                      getOptionLabel={(option) => option.label || ""}
                      options={selectedCountry}
                      style={{
                        border: "1px solid white",
                        borderRadius: "8px",
                        backgroundColor: "white",
                      }}
                      name="nationality"
                      onChange={(e, value) => {
                        setUserInfo((prev) => ({
                          ...prev,
                          nationality: value?.value,
                        }));
                        setValidation((prev) => ({
                          ...prev,
                          nationality: false,
                        }));
                      }}
                      className={
                        Validation.nationality
                          ? `${style.input} error_input_autocompleate`
                          : `${style.input}  `
                      }
                    />
                  </Grid>

                  <Grid size={{ lg: 4, md: 6, sm: 12 }}>
                    <label className={style.label}>
                      Email<span className="text-danger">*</span>
                    </label>
                    <Input
                      placeholder="Enter your email"
                      required
                      type="email"
                      name="email"
                      value={userInfo.email}
                      onChange={handleInput}
                      className={
                        Validation.email
                          ? `${style.input} error_input`
                          : style.input
                      }
                      onClick={() =>
                        setValidation((prev) => ({ ...prev, email: false }))
                      }
                    />
                  </Grid>
                  <Grid size={{ lg: 4, md: 6, sm: 12 }}>
                    <label className={style.label}>
                      Password<span className="text-danger">*</span>
                    </label>
                    <div className={style.positionRelative}>
                      <Input
                        placeholder="Enter your password"
                        type={showPassword1 ? "text" : "password"}
                        onChange={handleChangePass}
                        required
                        className={
                          Validation.password
                            ? `${style.input} error_input`
                            : style.input
                        }
                        onClick={() => {
                          setValidation((prev) => ({
                            ...prev,
                            password: false,
                          }));
                        }}
                      />
                      <span
                        className={style.positionAbsolute}
                        onClick={() => setShowPassword1(!showPassword1)}
                      >
                        {showPassword1 ? (
                          <div>{openedEyeIcon()} </div>
                        ) : (
                          <div>{closedEyeIcon()}</div>
                        )}
                      </span>
                    </div>
                  </Grid>
                </Grid>
                <br />

                <br />
                <div className="d-flex justify-content-center">
                  <button
                    type="submit"
                    //   disabled={!checkAgreement}
                    className={style.login_btn}
                    onClick={() => {
                      checkValidation();
                    }}
                  >
                    Sign Up
                  </button>
                </div>
                <div className="d-flex justify-content-center">
                  <div className="mt-3">
                    Already have an account?{" "}
                    <span
                      className={style.createAccount}
                      onClick={() => {
                        navigate("/");
                      }}
                    >
                      Login
                    </span>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Box>
    </Dialog>
    // </AuthLayout>
  );
}
